import React, { Fragment, useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Touriste from "../../images/pictos-ok/JE SUIS.svg";
import Localiste from "../../images/pictos-ok/JE SUIS_1.svg";
import {
  Typography,
  TextField,
  Select,
  MenuItem,
  Button,
  Box,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
import Breadcrumb from "../Breadcrumb";
//theme
import Theme, { useStyles } from "../Theme.js";
const CreateUser = (props) => {
  const location = useLocation();
  const [login, setLogin] = useState("");
  const [mdp, setMdp] = useState("");
  const [retour, setRetour] = useState("");
  const [pays, setPays] = useState("FR");
  const classes = useStyles();
  const [value, setValue] = useState("");
  const history = useHistory();

  useEffect(() => {
    // Quand le composant se charge, bloque la possibilité de passer sans répondre
    if (!location.state) {
      location.state = props.state;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <style>{".suivantprecedent{display:none;}"}</style>

      <Grid
        container
        style={{ maxWidth: "100%", paddingLeft: "30px", paddingRight: "30px" }}
      >
        <Box style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            className={classes.navButton2}
            onClick={
              () => props.setConnexion(1)
              /* history.push({
                pathname: "/user",
                state: {
                  theme: location.state.theme,
                  id_observation: location.state.id_observation,
                },
              })*/
            }
            style={{
              marginTop: 20,
              fontSize: 15,
              BackgroundColor: "#e50039",
              fontWeight: "bold",
            }}
          >
            Connectez-vous
          </Button>
          <br />
          <br />
          <div>OU</div>
          <Button
            variant="contained"
            color="primary"
            className={classes.navButton2}
            onClick={
              () => props.setConnexion(3)
              /*history.push({
                pathname: "/create-user-2",
                state: {
                  user_type: location.state.user_type,
                  theme: location.state.theme,
                  id_observation: location.state.id_observation,
                },
              })*/
            }
            style={{
              marginTop: 20,
              fontSize: 15,
              BackgroundColor: "#e50039",
              fontWeight: "bold",
            }}
          >
            Créér un compte
          </Button>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default CreateUser;
